module.exports = __webpack_public_path__ + "img/fb_event.cc03e833.svg";